import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ParametreModuleDto } from "../../../dto/GenApi.iNotPaie.Dto/ParametreModuleDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

@Component
export default class ModalUpdate extends Vue {
	public parametrage: ParametreModuleDto = { Id: 0 };

	public Init(id: number): void {
    	ServicesFactoryInstance.ParametrageModuleService.getParametrageModuleById(id, data => {
    		this.parametrage = data;
    	});
	}

	public update(): void {
    	ServicesFactoryInstance.ParametrageModuleService.updateParametrageModule(this.parametrage, () => {
    		NotificationServiceInstance.SendSuccess("Paramétrage modifié avec succès");
    		this.$emit("refresh");
    		this.annuler();
    	});
	}

	public annuler(): void {
    	$("#modalUpdate").modal("hide");
	}
}



// WEBPACK FOOTER //
// ./src/components/parametrageModule/modalUpdate/modalUpdate.ts